// extracted by mini-css-extract-plugin
export default {"icon_img":"oq","banner_wrapper":"pq","banner":"qq","title_wrapper":"rq","icons":"sq","weekly_freq":"tq","icon":"uq","icon_title":"vq"};
    if(module.hot) {
      // 1713969925828
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  